import * as Html from "../../util/Html.ts";
import ApiServer from "../../ApiServer.js";
import * as amplify from "../../util/amplify.ts";
import * as modal from "../../util/modal.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as i18n from "../../i18n.ts";
import {CalListCache} from "../../server/EventStore.js";
import {askCalendarUrl} from "../../calendar/calendar_modal.js";
import * as progressbar from "../../util/progressbar.ts";
import {MonthDatePicker} from "../../calendar/MonthDatePicker.ts";

import Icons from "../../svg/Icons.ts";

import TPL_ICAL from "../../modal/part/cal_edit_icalui.mustache";
import { MealplannerSettingsCache, updateMealplannerSettings } from "../../mealplanner/mealplannerApi.ts";
import { initPaneRight, openPaneRight } from "../../util/PaneRight.ts";
import { pickFileFromDevice } from "../../lib/FileUtils.ts";
import { checkEventLimitOntry } from "../../calendar/calendarclean.js";

Html.registerWidget('widget/specific/calendarmenu',{init:init})

ApiServer.types.CalendarGroupBean.prototype.hasExternalCalendar = function(){
  if(this.external && this.external.length){
    return true;
  }
  if(this.googles && this.googles.filter(function(cred){return cred.linked.length>0}).length){
    return true;
  }
  if(this.outlooks && this.outlooks.filter(function(cred){return cred.linked.length>0}).length){
    return true;
  }
  return false;
}
ApiServer.types.CalendarGroupBean.prototype.hasExternalCalendarError = function(){
  if(this.googles && this.googles.filter((cred)=>cred.errorCode && cred.linked.length).length){
    return true;
  }
  if(this.outlooks && this.outlooks.filter((cred)=>cred.errorCode && cred.linked.length).length){
    return true;
  }
  if(this.families.filter((cal)=>cal.errorCode).length){
    return true;
  }
  return false;
}

var node,lastCallResult,errorShown = false,datePicker;

async function widgetRefresh(isInit = false){
  initPaneRight()
  return CalListCache.need().then(function(res){
    import("../../calendar/calendarmenu.mustache").then(function(TPL){
      Html.setHtml(node,TPL,res);
      var 
        userSettings = FwDatas.getSettingsPerFamily()||{};
      
      datePicker = new MonthDatePicker(node.get(0).querySelector(".MonthDatePicker"),{
        showWeek:userSettings.calendarWeekNb,
        date:isInit||datePicker===undefined?undefined:datePicker.currentDate
      })

    })
    if(res.hasExternalCalendarError()){
      $('#calendar-error-dot').show();
    }
    lastCallResult = res;
    handleResult(res,"calendarSelection");
  });
}

function onCalendarSubscribe(calendarSubscriptionResponseBean){
  modal.closeModal();
  CalListCache.invalidate()
  widgetRefresh();
  
  if(calendarSubscriptionResponseBean.createdMetaId.length>1){
    modal.ask({
      title:"calendars.addedseveratitle",
      message:"calendars.addedseveralmessage",
      lottie:"images/lottie/anim_verified_check.json",
      button:[
        {title:"actions.continue",action:"modalclose"}
        ]
      });
  }else{
    modal.ask({
      title:"calendars.addedtitle",
      message:"calendars.addedmessage",
      lottie:"images/lottie/anim_verified_check.json",
      button:[
        {title:"actions.share",action:"modalclose|caledit|"+calendarSubscriptionResponseBean.createdMetaId[0]},
        {title:"actions.continue",action:"modalclose",class:"secondary"}
        ]
      });
  }
}

ApiServer["custom.caledit"]  = async function(form){
  var mpsettings = await MealplannerSettingsCache.need();
  if(mpsettings){
    $(form).find("input[type='time']").each((i,input)=>{
      if(input.value.length){
        mpsettings.columns.find(c=>c.type===input.name).timeSlot = input.value;
      }
    });
    await updateMealplannerSettings(mpsettings);
  }
  var 
    mainCalBean = ApiServer.flattenForm(form),
    subactivateInput = $(form).find('input[name=subactivate]');
  
  if(mainCalBean.useCalendarColor!==undefined){
    mainCalBean.useEventColor = (mainCalBean.useCalendarColor[0]!=='true')
    delete mainCalBean.useCalendarColor;
  }
  if(subactivateInput.length){
    mainCalBean.activated=false;
    subactivateInput.each((i,input)=>{
      ApiServer.evtcalupdate({metaId:input.value,activated:input.checked});
      if(input.checked){
        mainCalBean.activated=true;
      }
    })
  }
  //we must chain every call so do not use direct call with form
  ApiServer.evtcalupdate(mainCalBean);
  modal.closeModal();
  CalListCache.refresh().then(callist=>{
    import("../../calendar/calendarmenu.mustache").then(function(TPL){
      Html.setHtml(node,TPL,callist);
    })
    handleResult(callist,"calendarModification");
  
  })
}

function handleResult(res,amplifyEvent){
  var ids = [],i,j,obj,cred;
  var calInError = null;
  
  for(i=0;i<res.mine.length;i++){
    obj = res.mine[i];
    if(obj.activated){
      if(obj.calendars){
        obj.calendars.forEach(o=>{if(o.activated){ids.push(o.metaId)}})
      }else{
        ids.push(obj.metaId);
      }
    }
  }
  for(i=0;i<res.families.length;i++){
    obj = res.families[i];
    if(obj.errorCode) calInError = obj;
    if(obj.activated){
      ids.push(obj.metaId);
    }
  }
  for(i=0;i<res.googles.length;i++){
    cred = res.googles[i];
    for(j=0;j<cred.linked.length;j++){
      obj = cred.linked[j];
      if(obj.errorCode) calInError = obj;
      if(obj.activated){
        ids.push(obj.metaId);
      }
    }
    
  }
  for(i=0;i<res.outlooks.length;i++){
    cred = res.outlooks[i];
    for(j=0;j<cred.linked.length;j++){
      obj = cred.linked[j];
      if(obj.errorCode) calInError = obj;
      if(obj.activated){
        ids.push(obj.metaId);
      }
    }
  }
  if(res.external){
    for(i=0;i<res.external.length;i++){
      obj = res.external[i];
      if(obj.activated){
        ids.push(obj.metaId);
      }
    }
  }
  for(i=0;i<res.timetables.length;i++){
    obj = res.timetables[i];
    if(obj.activated){
      ids.push(obj.metaId);
    }
  }
  for(i=0;i<res.budgets.length;i++){
    obj = res.budgets[i];
    if(obj.activated){
      ids.push(obj.metaId);
    }
  }
  if(!errorShown && calInError){
    errorShown = true;
    modal.toast({
      emoji:'😒',
      text:"calendars.calerror.toast",
      button:[
        {title:"actions.learnmore",onclick:()=>{
          Html.triggerbystring(null,'calediterror|'+calInError.metaId)
          
          openPaneRight();
          var node = menu.querySelector('[data-fw-meta-id="'+calInError.metaId+'"]');
          if(node){
            node.scrollIntoView()
          } 
          
        }}
      ]
    })
  }
  amplify.publish(amplifyEvent,ids);
}

Html.register({
  calicalgenerate(){
    var 
      node = this.parents('.content'),
      metaId = this.metaId();
    ApiServer.evticalvisibleurl(true,metaId,function(url){
      Html.setHtml(node,TPL_ICAL,{icalurl:url})
    })
    
  },
  async calicalrefresh(){
    var 
      node = this.parents('.content'),
      metaId = this.metaId(),
      doit = await modal.confirm({title:"calendars.icalrefreshconfirmtitle",message:"calendars.icalrefreshconfirmmessage"})
      
    if(doit){
      ApiServer.evticalvisibleurl(true,metaId,function(url){
        Html.setHtml(node,TPL_ICAL,{icalurl:url})
      })
    }
  },
  calicaldelete(){
    var 
      node = this.parents('.content'),
      metaId = this.metaId();
    modal.confirmDelete({title:"calendars.icaldeleteconfirmtitle",message:"calendars.icaldeleteconfirmmessage"},function(){
      ApiServer.evticalvisibleurldelete(metaId,function(){
        Html.setHtml(node,TPL_ICAL,{})
      })
    })
  },
  
  evtcalactivate(metaId,activated){
    ApiServer.evtcalupdate({metaId:metaId,activated:activated});
    CalListCache.invalidate()
    widgetRefresh();
  },
  async evtcalaskdelete(metaId){
    var doit = await modal.askAsPromise({
      title:'calendars.caldelete.button',
      messageHTML:i18n.get('calendars.caldelete.text',FwDatas.get(metaId)),
      image:"/images/calendar_dialog_subscription_remove.svg",
      button:[{title:"calendars.caldelete.button",class:"negative",value:"true"}]
    })
    if(doit==='true'){
      modal.closeModal();
      ApiServer.evtcaldelete(metaId);
      CalListCache.invalidate()
      widgetRefresh().then(calGroup=>{
        modal.toast({text:'calendars.deleted',svg:Icons.ic_done})
      });
    }
  },
  googleeditcredential(credentialId){
    ApiServer.googlegetcredential(credentialId,function(cred){
      import("../../modal/calgoogle_edit.mustache").then(function(TPL){
        modal.openModal(TPL,cred);
      });
    });
    
  },  
  googlepick(credentialId,googleId){
    ApiServer.googleselectcalendar2(credentialId,googleId,onCalendarSubscribe);
  },  
  googleconnect(){
    ApiServer.googleAuthUri(function(uri){
      window.location = (uri);
    })
  },  
  outlookconnect(){
    ApiServer.outlookAuthUri(function(uri){
      window.location = (uri);
    })
  },
  outlookeditcredential(credentialId){
    ApiServer.outlookgetcredential(credentialId,function(cred){
      import("../../modal/caloutlook_edit.mustache").then(function(TPL){
        modal.openModal(TPL,cred);
      });
    });
  },
  outlookpick(credentialId,outlookId){
    ApiServer.outlookselectcalendar2(credentialId,outlookId,onCalendarSubscribe);
  },
  async icsconnect(){
    var url = await askCalendarUrl({title:'calendars.icssubscription'})
    if(url){
      ApiServer.evtcalsubscribe2(url,onCalendarSubscribe)
    }
  },
  async icalimporttype(){
    var TPL = await import("../../calendar/modal_importtype.mustache")
    modal.openModal(TPL,{})
  },
  async icalimportbyurl(){
    var url = await askCalendarUrl({
      title:'calendars.importbyurl.title',
      image:"/images/calendar_dialog_import_url.svg",
      message:"calendars.importbyurl.label",
      sub:"calendars.importbyurl.sub",
      placeholder:"calendars.importbyurl.placeholder",
      buttonName:"actions.import"
    })
    if(url){
      try{
        var resp = await ApiServer.evticalimport.setOptions({timeout:300000,progressbar:progressbar.standard})({file:url});
        if(resp.rightFlag ==='KO_PREMIUM'){
          var doit30 = await modal.askAsPromise({
            title:"errors.oops",
            message:"calendars.importicslimit",
            lottie:"/images/lottie/dizzy_face.json",
            button:[
              {title:"actions.gopremium",class:"premium",value:false,action:"takepremium"},
              {title:"actions.later",class:"secondary",value:true}
            ]
          })
          if(doit30){
            resp = await ApiServer.evticalimport.setOptions({timeout:300000,progressbar:progressbar.standard})({file:url,indexes:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]});
          }else{
            modal.closeModal();
            return;
          }
        }
        modal.closeModal();
        var key = (resp.updated)?(resp.created?'calendars.importicsresult2':'calendars.importicsresult3'):'calendars.importicsresult1'
        modal.toast({
          svg:Icons.ic_done,
          text:i18n.get(key,resp)
        });
        amplify.publish('eventUpdated')
      }catch(err){
        if(err.code==='408'){
          modal.oops('eventclean.import_limit_exceeded')
        }else{
          modal.oops('calendars.calbyurl.errortext');
        }
      }
    }
  },
  async icalimportbyfile(){
    var file = (await pickFileFromDevice('text/calendar'))[0]
    if(!file) return
    const
      eventsCount = await countEventInIcal(file),
      canAdd = await checkEventLimitOntry(undefined,eventsCount);
      
    if(!canAdd){
      modal.oops('eventclean.import_limit_exceeded')
      return;
    }  
    
    var indexes = [];
    if(FwDatas.getPermission("icsconnect")==='takepremium' && eventsCount>30){
      var result = await modal.askAsPromise({
        title:"errors.oops",
        message:"calendars.importicslimit",
        lottie:"/images/lottie/dizzy_face.json",
        button:[
          {title:"actions.gopremium",class:"premium",value:false,action:"takepremium"},
          {title:"actions.later",class:"secondary",value:true}
        ]
      })
      if(result){
        indexes=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];
      }else{
        return;
      }
    }

    try{
      var resp = await ApiServer.evticalimport.setOptions({timeout:300000,progressbar:progressbar.standard})({file,indexes});
      var key = (resp.updated)?(resp.created?'calendars.importicsresult2':'calendars.importicsresult3'):'calendars.importicsresult1'
      modal.toast({
        svg:Icons.ic_done,
        text:i18n.get(key,resp)
      });
      amplify.publish('eventUpdated')
    }catch(err){
      if(err.code==='408'){
        modal.oops('eventclean.import_limit_exceeded')
      }else{
        modal.oops('calendars.calbyurl.errortext');
      }
    }
    
  },
  
  async calcountrypicker(){
    //prepare proposals
    var proposal = lastCallResult.suggestions.map(calproposal=>{
      var 
        name = i18n.getCountry(calproposal.countryCode,calproposal.countryLang),
        codePoints = calproposal.countryCode
          .toUpperCase()
          .split('')
          .map(char =>  127397 + char.charCodeAt()),
        emoji = String.fromCodePoint(...codePoints);
      
      return {title:name,emoji:emoji,calendarIds:calproposal.calendarIds};
    })
    proposal.sort((a,b)=>{
      return a.title.localeCompare(b.title)
    })
    
    //propose
    var button = await modal.pick({
      title:'calendars.pickcountry',
      gap:"var(--space-xs)",
      button:proposal
    })
    //handle picked proposition
    if(button!==null){
      var 
        metaIds = button.calendarIds,
        calendarGroupBean = await CalListCache.need(),
        alreadyCount = calendarGroupBean.mine.filter(cal=>metaIds.indexOf(cal.metaId)>-1).length;
      if(alreadyCount==metaIds.length){
        modal.toast({text:'calendars.countryalreadyadded',emoji:'🤔'})
        return;
      }
      metaIds.forEach(metaId=>{
        ApiServer.evtcalupdate({metaId:metaId,activated:true});
      })
      modal.closeModal();
      CalListCache.invalidate()
      await widgetRefresh()
      //Html.triggerbystring(null,"caledit|"+metaIds[0])
      modal.toast({text:'calendars.countryadded',emoji:'🎉'})
    
    }
  }
  
})

ApiServer["custom.outlookselectcalendar"] = function(form,onsuccess,onerror){
  var value = Array.from($('input[name="outlookId"]:checked')).map(t=>$(t).val());
  if(value.length===0){
    modal.alert('calendars.mustpick');
  }else{
    ApiServer.outlookselectcalendar2(form.credentialId.value,value,onCalendarSubscribe,onerror)
  }
};
ApiServer["custom.googleselectcalendar"] = function(form,onsuccess,onerror){
  var value = Array.from($('input[name="googleId"]:checked')).map(t=>$(t).val());
  if(value.length===0){
    modal.alert('calendars.mustpick');
  }else{
    ApiServer.googleselectcalendar2(form.credentialId.value,value,onCalendarSubscribe,onerror)
  }
};

async function countEventInIcal(file){
  return new Promise((resolve,reject)=>{
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      var fileAsString = event.target.result;
      resolve((fileAsString.match(/BEGIN:VEVENT/g) || []).length);
    });
    reader.addEventListener('error', (error) => {
      reject(error);
    });
    reader.readAsText(file);  
  })
  
}


export function init(obj){
  node = obj;
  widgetRefresh(true);
}